import { useAtomValue } from 'jotai';

import { $inventoryItemsById } from '~/modules/trade/_state/loadForm.state';
import { InventoryItemRecord } from '~/modules/trade/types/load';

export const useInventoryItem = (
  itemId: string | null | undefined,
): InventoryItemRecord | undefined => {
  const itemsById = useAtomValue($inventoryItemsById);
  if (!itemId) return undefined;
  return itemsById[itemId];
};
